import React from 'react'
import { useTranslation } from 'react-i18next'
import { client } from '../api/client'
import { useAuthStore } from '../stores/auth'

const LANGUAGES = {
  en: {
    text: 'EN',
    label: 'English'
  },
  el: {
    text: 'GR',
    label: 'Greek'
  }
}

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const { isAuthenticated, updateParent } = useAuthStore()

  const changeLanguage = async (lng: string) => {
    // Change language locally first for immediate feedback
    i18n.changeLanguage(lng)
    
    // If user is authenticated, update the preference in the backend
    if (isAuthenticated) {
      try {
        const response = await client.patch('/profile/', {
          language_preference: lng
        })
        
        // Update the parent data in the store with the response
        updateParent(response.data)
      } catch (error) {
        console.error('Failed to update language preference:', error)
        // Even if the API call fails, we keep the UI language change for better UX
      }
    }
  }

  return (
    <div className="flex items-center space-x-2">
      {Object.entries(LANGUAGES).map(([code, { text, label }]) => (
        <button
          key={code}
          onClick={() => changeLanguage(code)}
          className={`w-10 h-10 flex items-center justify-center text-sm font-bold transition-colors ${
            i18n.language === code
              ? 'bg-neobrutalism-accent shadow-brutal-sm'
              : 'bg-white border-2 border-black'
          }`}
          title={label}
          aria-label={`Switch to ${label}`}
        >
          {text}
        </button>
      ))}
    </div>
  )
} 